<template>
  <liste-template>
    <template #header>
      <h1 class="title is-size-3">{{ $t('listeSignatureElectroniqueEncours.title')}}</h1>
      <breadcrumb :breadcrumb="breadcrumb"/>
    </template>
    <template #bar-left>
      <form @submit.prevent="recherche()" class="column is-6 pdl-0 pdr-0">
        <b-input
          :placeholder="$t('general.button.search')"
          type="search"
          icon="magnify"
          v-model="criteresRecherche.auto">
        </b-input>
      </form>
      <div class='column is-narrow'>
        <button class="button"  @click='setShowFiltre'>
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">
            {{$t('general.button.filtre')}}
            <label class="has-text-weight-bold"
                    :class="nombreCritere > 0 ? '' : 'is-invisible'">
              ({{ nombreCritere }})
            </label>
          </span>
        </button>
        <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
          <b-icon icon="close-circle" type="is-danger"></b-icon>
        </span>
      </div>
    </template>
    <template #bar-right>
      <div class="column is-narrow">
        <button
          class="button"
          @click="checkPermissions(constantes.SIGNATURE_ELECTRONIQUE.exporter)
          ? exporter() : showPopUp()"
          :class="{ 'button-access-no-permission'
            : !checkPermissions(constantes.SIGNATURE_ELECTRONIQUE.exporter) }">
          <b-icon icon="database-export" size="is-small"  type="is-default"
            :class="{'text-access-no-permission' :
              !checkPermissions(constantes.SIGNATURE_ELECTRONIQUE.exporter) }">
          </b-icon>
          <span class="is-size-7"
            :class="{ 'text-access-no-permission' :
              !checkPermissions(constantes.SIGNATURE_ELECTRONIQUE.exporter) }">
             {{$t('general.button.export')}}
          </span>
         </button>
      </div>
      <parametrage-table
        :reference-table="constantes.REFERENCE_TABLE_LISTE_SIGNATURE"
        @endLoadParamtre="finChargement = true">
      </parametrage-table>
    </template>
    <template #content>
      <v-server-table url=""
        :columns="getColumns"
        :options="options"
        @loaded="finLoading"
        @loading="debutLoading"
        :ref="constantes.REFERENCE_TABLE_LISTE_SIGNATURE"
        v-if="finChargement">
        <template slot='afterTable'>
          <table-items-in-view
            :perPage="resultPerPage"
            @input="$refs[constantes.REFERENCE_TABLE_LISTE_SIGNATURE].setLimit($event)" />
        </template>
        <template slot="dateEnvoie" slot-scope="props">
          {{ func.formatDate(props.row.dateEnvoie) }}
        </template>
        <template slot="contratEtatSignature" slot-scope="props">
          {{ getEtatLibelle(props.row.contratEtatSignature) }}
        </template>
        <template slot="demandeur" slot-scope="props">
          {{ props.row.demandeur }}
        </template>
        <template slot="commercial" slot-scope="props">
          {{ getLibelleUser(props.row.commercialId) }}
        </template>
        <template slot="assistant" slot-scope="props">
          {{ getLibelleUser(props.row.assistantId) }}
        </template>
        <template slot="dateSignature" slot-scope="props">
          {{ func.formatDate(props.row.dateSignature) }}
        </template>
        <template slot="referenceCode" slot-scope="props">
         <router-link-blank v-if="getNameRoute(props.row) !== null"
          :to="getNameRoute(props.row)"
          :message="props.row.referenceCode"></router-link-blank>
        <span v-else>{{ props.row.referenceCode }}</span>
        </template>
        <template slot="tiers" slot-scope="props">
          <router-link-blank v-if="props.row.tiersId"
            :to="{ name: 'c.bodac.clients/contacts-client',
              params: {id: props.row.tiersId}}"
            :message="props.row.tiers"/>
        </template>
        <template slot="contact" slot-scope="props">
          <router-link-blank v-if="props.row.contactId"
            :to="{ name: 'c.bodac.clients/contacts-contacts',
              params: {id: props.row.contactId}}"
            :message="props.row.contact"/>
        </template>
      </v-server-table>
    </template>
    <template #after-content>
      <a ref="lienDownload"></a>
    </template>
    <template #filter>
      <div class="componentBrief" v-show="showFiltre">
        <filtre-signature-electronique
          ref="filtreListeSignatureElectronique"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter"/>
      </div>
    </template>
  </liste-template>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Breadcrumb from '@/components/general/breadcrumb';
import ListeTemplate from '@/components/general/template/listeTemplate';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import messageErreur from '@/services/general/messageErreur';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { SET_CRITERE } from '@/store/modules/commun/signatureElectronique-mutation-type';
import { REFERENCE_TABLE_LISTE_SIGNATURE } from '@/configuration/general/referenceTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import ParametrageTable from '@/components/general/parametrageTable';
import formatDate from '@/services/general/formatDate';
import exportExcel from '@/api/exportExcel';
import { SIGNATURE_ELECTRONIQUE } from '@/configuration/general/permissionsParametrageConf';
import * as signatureElectroniqueConf from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import FiltreSignatureElectronique from '@/components/signatureElectronique/filtreSignatureElectronique';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Societe = createNamespacedHelpers('societe');
const SignatureElectronique = createNamespacedHelpers('signatureElectronique');
const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'l_LignesSignatureElectroniqueEncours',
  components: {
    Breadcrumb,
    ListeTemplate,
    TableItemsInView,
    ParametrageTable,
    routerLinkBlank,
    FiltreSignatureElectronique,
  },
  data() {
    return {
      constantes: {
        REFERENCE_TABLE_LISTE_SIGNATURE,
        SIGNATURE_ELECTRONIQUE,
      },
      resultPerPage: RESULTS_PER_PAGE,
      finChargement: false,
      func: {
        formatDate,
      },
      showFiltre: false,
      allUser: [],
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...SignatureElectronique.mapGetters({
      signatures: 'items',
      total: 'totalCount',
      criteresRecherche: 'criteresRecherche',
      lastPayload: 'lastPayload',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeSignatureElectroniqueEncours.title'), route: { name: 'l.parametrage.signature_electronique' }, isActive: true },
      ];
    },
    columns() {
      return [
        {
          name: 'dateEnvoie', show: true, text: 'listeSignatureElectroniqueEncours.tab.dateEnvoie', sortable: true,
        },
        {
          name: 'contratEtatSignature', show: true, text: 'listeSignatureElectroniqueEncours.tab.contratEtatSignature', sortable: true,
        },
        {
          name: 'demandeur', show: true, text: 'listeSignatureElectroniqueEncours.tab.demandeur', sortable: true,
        },
        {
          name: 'dateSignature', show: true, text: 'listeSignatureElectroniqueEncours.tab.dateSignature', sortable: true,
        },
        {
          name: 'referenceCode', show: true, text: 'listeSignatureElectroniqueEncours.tab.referenceCode', sortable: true,
        },
        {
          name: 'tiers', show: true, text: 'listeSignatureElectroniqueEncours.tab.tiers', sortable: true,
        },
        {
          name: 'contact', show: true, text: 'listeSignatureElectroniqueEncours.tab.contact', sortable: true,
        },
        {
          name: 'commercial', show: true, text: 'listeSignatureElectroniqueEncours.tab.commercial', sortable: false,
        },
        {
          name: 'assistant', show: true, text: 'listeSignatureElectroniqueEncours.tab.assistant', sortable: false,
        },
      ];
    },
    getHeadings() {
      return this.columns.reduce((old, a) => ({ ...old, [a.name]: this.$i18n.t(a.text) }), {});
    },
    getSortable() {
      return this.columns.filter(c => c.sortable).map(c => c.name);
    },
    getColumns() {
      return this.columns.filter(c => c.show).map(c => c.name);
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: this.getHeadings,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: this.getSortable,
        columnsClasses: {
          dateSignature: 'colonneWith180',
          dateEnvoie: 'colonneWith180',
          contratEtatSignature: 'colonneWith180',
        },
        requestFunction: (async (data) => {
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          await updateCritereWithParametreInterne(data.query);
          data.query.societeId = this.societeActiveId;
          data.query.referencesSignature = [this.$route.params.type];
          return this.actionsLoadSignatures(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.signatures,
            count: this.total,
          };
        }),
      };
    },
    nombreCritere() {
      let nombreCritere = 0;
      const banCritere = ['auto', 'societeId', 'referencesSignature'];
      nombreCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...SignatureElectronique.mapActions({
      actionsLoadSignatures: 'loadSignatures',
    }),
    ...SignatureElectronique.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    recherche() {
      this.$refs[this.constantes.REFERENCE_TABLE_LISTE_SIGNATURE].refresh();
    },
    getEtatLibelle(etatContrat) {
      const find = signatureElectroniqueConf.LISTE_ETAT_CONTRAT_SIGNATURE
        .find(etat => etat.code === etatContrat);
      return this.$t(find?.libelle) || null;
    },
    goFirstPage() {
      this.$refs[this.constantes.REFERENCE_TABLE_LISTE_SIGNATURE].setPage(1);
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getNameRoute(data) {
      switch (data.referenceSignature) {
        case signatureElectroniqueConf.DEVIS:
          return {
            name: 'c.bodac.devis',
            params: {
              id: data.referenceId,
            },
          };
        case signatureElectroniqueConf.COMMANDE:
          return {
            name: 'c.bodac.commandes',
            params: { id: data.referenceId },
          };
        default: return null;
      }
    },
    async exporter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel({
          typeDonnee: signatureElectroniqueConf.EXPORT_EXCEL_SIGNATURE_ELECTRONIQUE,
          typeExport: null,
          filtres: this.lastPayload,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    getLibelleUser(userId) {
      const user = this.allUser.find((user) => {
        return user.id === userId;
      });
      if (!user) return '';
      return [user.nom, user.prenom]
        .filter(el => !!el).join(' ');
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreListeSignatureElectronique.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeSignatureElectronique.viderCritere();
      await this.$refs.filtreListeSignatureElectronique.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.goFirstPageAndCheckChangement, this.recherche);
      const critere = cloneDeep(this.criteresRecherche);
      await updateCritereWithParametreInterne(critere);
      this.setCritereRecherche(critere);
      this.setInformationPage(this.$t('pageMultiModule.signatureElectronique.liste'));
      await this.loadParametreUtilisateur();
      this.allUser = await this.parametre(PARAMETRES_KEYS.utilisateur);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style>

</style>
